// extracted by mini-css-extract-plugin
export var askAiIcon = "_r0-9";
export var container = "_r0-0";
export var groupSeparator = "_r0-a";
export var highlight = "_r0-4";
export var resultIcon = "_r0-5";
export var resultItem = "_r0-7";
export var resultSubtitle = "_r0-3";
export var resultTitle = "_r0-2";
export var resultsList = "_r0-1";
export var searchGroup = "_r0-6";
export var selected = "_r0-8";